// Gedeelde id's voor 'sleep-foto-naar-hoofdfoto'. `tablist` is de eigen CDK cdkDropList-id van de
// fotolijst-grid (image-tablist, reorder-only). `main` is GEEN CDK drop-list (meer) — het DOM-id van
// de hoofdfoto-box (image-box-details) waar de grid zelf tegenaan hittest (zie
// ImageTablistComponent.emit_onDragMoved/__isOverMainBox — en _TabPageService.photoDragPreview_set
// voor waarom geen CDK cdkDropListConnectedTo). Eén constante zodat bron en doel hetzelfde id
// gebruiken over de componentgrenzen heen.
export const photoDropList = {
    tablist: 'image-tablist-drop',
    main: 'main-photo-drop',
} as const;
